// extracted by mini-css-extract-plugin
export var orderSummary = "_o3-0";
export var showMoreLessButton = "_o3-1";